import { Box } from '@mui/material';
import { format } from 'date-fns';
import { GenerativeModelFile } from 'entities/generative-models/types';
import { Column } from 'shared/ui/tables/_common/types';
import { TableTranslationLabel } from 'shared/ui/tables/_common/ui/TableTranslationLabel';
import { ColorPalette } from 'shared/consts/colorPalette';
import { SmallIconButton } from 'shared/ui/SmallIconButton';

export type GenerativeModelFilesColumns = GenerativeModelFile & {
	id: string;
	openEditor: (file: GenerativeModelFile) => void;
	deleteHandler: (file: GenerativeModelFile) => void;
};

export const GenerativeModelFilesTableColumns: Array<Column<GenerativeModelFilesColumns>> = [
	{
		field: 'status',
		commonCellSettings: {
			style: {
				textAlign: 'center',
				minWidth: '170px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="status" />,
		},
		bodyCellSettings: {
			renderCell: (file) => {
				const bgColor =
					file?.status === 'UPLOADED'
						? ColorPalette.jungleGreen
						: file?.status === 'UPLOADING'
						? ColorPalette.fuelYellow
						: ColorPalette.violetRed;
				const text =
					file?.status === 'UPLOADED'
						? 'uploaded'
						: file?.status === 'UPLOADING'
						? 'uploading'
						: 'error';
				return (
					<Box
						sx={{
							display: 'inline-block',
							margin: '0 10px',
							padding: '6px 14px',
							borderRadius: '10px',
							backgroundColor: bgColor,
						}}
					>
						<TableTranslationLabel label={text} color={ColorPalette.white} />
					</Box>
				);
			},
		},
	},
	{
		field: 'name',
		commonCellSettings: {
			style: {
				minWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="name" />,
		},
		bodyCellSettings: {
			renderCell: (file) => file?.fileName || '',
		},
	},
	{
		field: 'size',
		commonCellSettings: {
			style: {
				minWidth: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="file_size" />,
		},
		bodyCellSettings: {
			renderCell: (file) => file?.size || '',
		},
	},
	{
		field: 'source',
		commonCellSettings: {
			style: {
				minWidth: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="source" />,
		},
		bodyCellSettings: {
			renderCell: (file) => file?.size || '',
		},
	},
	{
		field: 'createdDate',
		commonCellSettings: {
			style: {
				minWidth: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="create_date" />,
		},
		bodyCellSettings: {
			prepareField: (file) =>
				file?.createdAt ? format(new Date(file?.createdAt), 'dd/MM/yyyy') : null ?? '-',
		},
	},
	{
		field: 'lastChanges',
		commonCellSettings: {
			style: {
				minWidth: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="last_changes" />,
		},
		bodyCellSettings: {
			prepareField: (file) =>
				file?.updatedAt ? format(new Date(file?.updatedAt), 'dd/MM/yyyy') : null ?? '-',
		},
	},
	{
		field: 'options',
		commonCellSettings: {
			style: {
				minWidth: '150px',
			},
		},
		bodyCellSettings: {
			renderCell: (file) => {
				return (
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
						<SmallIconButton iconId={'close_round'} onClick={() => file?.deleteHandler(file)} />
						<Box sx={{ transform: 'rotate(180deg)' }}>
							<SmallIconButton
								iconId={'custom_arrow_down'}
								onClick={() => file?.openEditor(file)}
							/>
						</Box>
					</Box>
				);
			},
		},
	},
];
